<template>
    <div v-if="options_loaded && passed_filter">
        <div class="designeroption" :data-designer-component-id="component_id">
            <h3>
                {{ title }}
                <designer-question-popup-info
                    v-if="has_popup_info"
                    :popup_info_title_html="popup_info_title_html"
                    :popup_info_inner_html="popup_info_inner_html"
                ></designer-question-popup-info>
            </h3>
            <div class="stylesoption">
                <div class="addonoption">
                    <table>
                        <tbody>
                        <tr>
                            <td width="33%">&nbsp;</td>
                            <td width="33%">External</td>
                            <td width="33%">Internal</td>
                        </tr>
                        <tr v-for="option in filtered_option_list">
                            <td>{{option.label}}</td>
                            <td>
                                <span>
                                    <select class="form-control addons" v-model="localTarget.external[option.value.external]">
                                        <option v-for="i in 6" :value="i">{{ i }}</option>
                                    </select>
                                </span>
                            </td>
                            <td>
                                <span>
                                    <select class="form-control addons" v-model="localTarget.internal[option.value.internal]">
                                        <option v-for="i in 6" :value="i">{{ i }}</option>
                                    </select>
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Select Any Required Trim Packs';
                }
            },
            component_id: {
                default(){
                    return 'trim_packs';
                }
            },
            frameProfile: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            frameColourInternal: {
                required: true,
            }
        },
        mounted(){
            for (var propertyName in this.localTarget) {
                if (Array.isArray(this.localTarget[propertyName])){
                    this.localTarget[propertyName] = {};
                }
            }
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            passed_filter(){
                return this.variable_ready(this.frameProfile);
            },
            url(){
                return '/api/options/' + this.fabricator + '/trim-packs-extended?profile=' + this.frameProfile + '&frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal;
            },
            cache_key(){
                return '_' + this.frameProfile + '_' + this.frameColourExternal + '_' + this.frameColourInternal + '_' + this.doorRange;
            }
        },
        methods: {
            select_first(){
                // Comment because Mike
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
            'filtered_option_list': function (new_val) {
                if (new_val.length > 0){

                    let options_to_check = [
                        this.localTarget.external,
                        this.localTarget.internal,
                    ];

                    options_to_check.forEach((val) => {
                        console.log(val);
                        for (var propertyName in val) {
                            if (new_val.find((el) => {
                                return parseInt(el.value) === parseInt(propertyName);
                            }) === undefined) {
                                delete val[propertyName];
                            }
                        }
                    });
                }
            },
        }
    }
</script>
